module.exports = __webpack_public_path__ + "static/media/login-oauth-error-monsters.71508cba.png";